var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mpBody"},[(!_vm.loading)?_c('div',{staticClass:"loading"},[(_vm.schemeUrl)?_c('button',{staticClass:"btn",on:{"click":_vm.openMp}},[_vm._v("打开小程序")]):_c('h1',[_vm._v("未获取到微信小程序SchemeUrl")])]):_c('div',{staticClass:"loading"},[_c('h1',[_vm._v("加载中...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }